<template>
  <form action="" class="md:min-w-[500px] p-10 md:p-12">
    <div class="modal-card">
      <header class="modal-card-head mb-4">
        <p class="modal-card-title font-bold text-xl">Welcome Back!</p>
      </header>
      <section class="modal-card-body">
        <o-field
          label="Email"
          :message="messages.email"
          :variant="messages.email ? 'danger' : ''">
          <o-input
            type="input"
            v-model="email"
            placeholder="Your email"
            class="test">
          </o-input>
        </o-field>
        <o-field
          label="Password"
          :message="messages.password"
          :variant="messages.password ? 'danger' : ''">
          <o-input
            type="password"
            v-model="password"
            placeholder="Your password"
            password-reveal>
          </o-input>
        </o-field>
        <o-field>
          <o-checkbox variant="primary">Remember me</o-checkbox>
        </o-field>
        </section>
      <footer class="modal-card-foot mt-6">
        <o-button
          @click="login"
          variant="primary"
          class="w-full rounded-lg py-6 shadow-md">
          Login
        </o-button>
        <div class="o-field__message o-field__message-danger text-center">
          {{ errorMsg }}
        </div>
        <o-button
          @click="$emit('close')"
          type="button"
          variant="cancel"
          class="mt-4 w-full rounded-lg py-6 shadow-md">
          Close
        </o-button>
        <div class="mt-5">
          Don’t have an account?
          <a
            @click="showSignUpModel"
            href="#"
            class="font-medium ml-2">
            Sign Up
          </a>
        </div>
      </footer>
    </div>
  </form>
</template>

<script>
import router from '../router'
import { USER } from '@/data/user'
import { EmailRegex } from '@/utils/regex'
import SignUpForm from '@/components/SignUpForm.vue'

export default {
  data() {
    return {
      USER,
      email: '',
      password: '',
      messages: {
        email: '',
        password: '',
      },
      errorMsg: '',
    }
  },
  watch: {
    email() {
      this.checkEmailValid()
    },
    password() {
      this.checkPasswordValid()
    },
  },
  computed: {
    loginId() {
      const userIndex = this.USER.findIndex(user => this.email === user.email && this.password === user.password)
      if (userIndex !== -1) return this.USER[userIndex].id
      return null
    },
    loginRole() {
      const userIndex = this.USER.findIndex(user => this.email === user.email && this.password === user.password)
      if (userIndex !== -1) return this.USER[userIndex].role
      return null
    },
    isFormValid() {
      return (this.messages.email === '' && this.messages.password === '')
    },
  },
  methods: {
    showSignUpModel() {
      this.$emit('close')
      this.$oruga.modal.open({
        component: SignUpForm,
        trapFocus: true,
        contentClass: 'rounded-[2.5rem]',
      })
    },
    checkEmailValid() {
      if (this.email === '') {
        this.messages.email = 'Email is required!'
        return
      } else {
        // eslint-disable-next-line no-useless-escape
        if (!EmailRegex.test(this.email)) this.messages.email = 'Invalid Email Address!'
        else this.messages.email = ''
      }
    },
    checkPasswordValid() {
      if (this.password === '') this.messages.password = 'Password is required!'
      else this.messages.password = ''
    },
    formSubmit() {
      this.messages.email = ''
      this.messages.password = ''
      this.checkEmailValid()
      this.checkPasswordValid()
    },
    login() {
      this.formSubmit()
      if (!this.loginRole) this.errorMsg = 'Account not existed or password wrong!'
      if (this.isFormValid && this.loginRole && this.loginId) {
        this.$emit('close')
        localStorage.setItem('influme_login', this.loginId)
        router.push(`/${this.loginRole}`)
      }
    },
  },
}
</script>